import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import AdminLayout from "../../components/admin/Layout/AdminLayout";

export default function CreateBlog() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "",
    excerpt: "",
    tags: "",
    coverImage: null,
    content: "",
    category: "",
  });

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/blogs/categories");
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to fetch categories:", err);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setForm({ ...form, coverImage: e.target.files[0] });
  };

  const handleSubmit = async (status = "draft") => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("title", form.title);
      formData.append("excerpt", form.excerpt);
      formData.append("content", form.content);
      formData.append("status", status);
      formData.append("category", form.category);

      form.tags
        .split(",")
        .map((t) => t.trim())
        .forEach((tag) => formData.append("tags[]", tag));

      if (form.coverImage) formData.append("coverImage", form.coverImage);

      const res = await api.post("/blogs/admin/post", formData);

      alert("Blog saved successfully");
      navigate(`/blog/article/${res.data.blog.slug}`);
    } catch (err) {
      console.error("CREATE BLOG ERROR:", err);
      alert("Failed to create blog");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div style={styles.container}>
        <h1 style={styles.title}>Create Blog Post</h1>

        <div style={styles.card}>

          {/* TITLE */}
          <div style={styles.field}>
            <label style={styles.label}>Title</label>
            <input
              name="title"
              placeholder="Enter blog title"
              value={form.title}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          {/* EXCERPT */}
          <div style={styles.field}>
            <label style={styles.label}>Excerpt</label>
            <input
              name="excerpt"
              placeholder="Short summary of the blog"
              value={form.excerpt}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          {/* CATEGORY + TAGS */}
          <div style={styles.grid}>
            <div style={styles.field}>
              <label style={styles.label}>Category</label>
              <select
                value={form.category}
                onChange={(e) =>
                  setForm({ ...form, category: e.target.value })
                }
                style={styles.input}
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={styles.field}>
              <label style={styles.label}>Tags</label>
              <input
                name="tags"
                placeholder="seo, marketing, growth"
                value={form.tags}
                onChange={handleChange}
                style={styles.input}
              />
            </div>
          </div>

          {/* COVER IMAGE */}
          <div style={styles.field}>
            <label style={styles.label}>Cover Image</label>

            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={styles.input}
            />

            {form.coverImage && (
              <img
                src={URL.createObjectURL(form.coverImage)}
                alt="preview"
                style={styles.preview}
              />
            )}
          </div>

          {/* CONTENT */}
          <div style={styles.field}>
            <label style={styles.label}>Content</label>

            <textarea
              name="content"
              rows="14"
              placeholder="Write blog content..."
              value={form.content}
              onChange={handleChange}
              style={styles.textarea}
            />
          </div>

          {/* ACTION BUTTONS */}
          <div style={styles.actions}>
            <button
              style={styles.draftBtn}
              onClick={() => handleSubmit("draft")}
              disabled={loading}
            >
              Save Draft
            </button>

            <button
              style={styles.publishBtn}
              onClick={() => handleSubmit("published")}
              disabled={loading}
            >
              Publish
            </button>
          </div>

        </div>
      </div>
    </AdminLayout>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
  },

  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "20px",
  },

  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "30px",
    border: "1px solid #e5e7eb",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px",
  },

  field: {
    marginBottom: "20px",
    display: "flex",
    flexDirection: "column",
  },

  label: {
    marginBottom: "6px",
    fontWeight: "600",
    fontSize: "14px",
  },

  input: {
    padding: "10px 12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
  },

  textarea: {
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    resize: "vertical",
  },

  preview: {
    width: "220px",
    marginTop: "10px",
    borderRadius: "8px",
  },

  actions: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
  },

  draftBtn: {
    padding: "10px 18px",
    background: "#6b7280",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },

  publishBtn: {
    padding: "10px 18px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};